var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FomularioComum',{attrs:{"titulo":_vm.titulo,"buttons":_vm.buttons,"nome":'Categoria',"disable":_vm.user.leitura == true,"opcao":_vm.opcao,"data":_vm.dado},on:{"onSave":_vm.manter,"onCancel":_vm.voltar}})}
var staticRenderFns = []

export { render, staticRenderFns }